import me from "models/me";

export default (flags) => (nextState, replace, callback) => {
    // allow nuorder users direct access to Marketplace
    if (!flags?.marketplaceAccessNu70087 || !(me.marketplace_access || me.isNuOrderUser())) {
        replace({ pathname: "/404" });
    }
    callback();
};
